<template>
  <b-row class="px-1">
    <b-col class="vedio-list mb-1" sm="12" md="4" xl="4" v-for="(item,index) in videoData" :key="index" @click="goToDetail(item)">
      <div class="left video-height">
        <div class="img-cover"></div>
        <img :src="item.sourceUrl" alt width="100%" />
        <img src="@/assets/imgs/video/video.png" alt class="play" />
      </div>
      <div class="right">
        <div class="right-txt">{{item.postTitle}}</div>
        <div class="date">{{item.postDate}}</div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "VedioList",
  data() {
    return {};
  },
  props: ["videoData"],
  mounted() {
    this.handelWidth();
    this.handelImg();
  },
  methods: {
    handelImg() {
      this.videoData.forEach((item, index) => {
        var alllength = item.sourceUrl.length;
        var pointlength = item.sourceUrl.lastIndexOf(".");
        var str1 = item.sourceUrl.substr(0, pointlength);
        var str2 = item.sourceUrl.substr(pointlength, alllength);
        var newStr;
        newStr = str1+ '_related' +str2;
        this.videoData[index].sourceUrl = newStr;
      });
    },
    handelWidth() {
      // console.log("newList");
      var container = document.getElementsByClassName("video-height");
      this.playerHeight = container[0].clientWidth / (16 / 9) + "px";
      for (var i = 0; i < container.length; i++) {
        container[i].style.height = this.playerHeight;
      }
    },
    goToDetail(item) {
      this.$router.push({
        path: "/detail",
        query: {
          postId: item.postId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 768px) {
  .vedio-list {
    overflow: hidden;
    cursor: pointer;
    font-size: 0.48rem;
    .left {
      position: relative;
      height: 3rem;
      img {
        height: 100%;
        width: 100%;
      }
      .play {
        width: 0.6rem !important;
        height: 0.6rem !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .right {
      .right-txt {
        font-size: 0.16rem;
        color: #101010;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
        font-weight: 700;
        margin: 0.1rem 0;
      }
      .date {
        color: #999999;
        font-size: 0.14rem;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .vedio-list {
    cursor: pointer;
    width: 100%;
    height: 2.5rem;
    float: left;
    font-size: 0.48rem;
    .left {
      height: 2.3rem;
      position: relative;
      width: 4rem;
      float: left;
      img {
        width: 100%;
        height: 100%;
      }
      .play {
        width: 0.9rem;
        height: 0.9rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .right {
      height: 2.5rem;
      .right-txt {
        padding-left: 0.2rem;
        color: #101010;
        width: calc(100% - 4rem);
        float: left;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        font-weight: 400;
        font-weight: bold;
        line-clamp: 2;
        height: 1.1rem;
        margin-top: 0.3rem;
        font-size: 0.35rem;
      }
      .date {
        float: left;
        height: 1rem;
        color: #999999;
        width: calc(100% - 4.5rem);
        font-size: 0.3rem;
        line-height: 1rem;
        padding-left: 0.2rem;
      }
    }
  }
}
</style>